import React from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';

import { Label } from 'components';

const TextField = ({
  label,
  sublabel,
  suffix,
  containerClassName,
  className,
  asterisk = false,
  bold,
  ...rest
}) => {
  return (
    <div className={containerClassName || ''}>
      <Label label={label} bold={bold} asterisk={asterisk}/>
      {sublabel && <i><Label id="custom-field-label" label={sublabel} sublabel={true}/></i>}
      <Input
        {...rest}
        className={`custom-textfield ${className}`}
        suffix={suffix}
      />
    </div>
  );
};

TextField.propTypes = {
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  className: PropTypes.string,
};

export default TextField;
